const _Colors = {
    teal: '#003d4c' /* Teal the Burn        */,
    white: '#ffffff' /* White                */,
    mint: '#00baa4' /* Bright MoveMint      */,
    lightMint: '#9fefd2' /* Light MoveMint       */,
    pink: '#f249ad' /* Bright P.Ink         */,
    lightPink: '#f26dbc' /* Light P.Ink          */,
    gold: '#fcb400' /* Bright Goals Gold    */,
    lightGold: '#fbd132' /* Light Goals Gold     */,
    lime: '#bcf91a' /* Bright Hilit Lime    */,
    lightLime: '#d0f964' /* Light Hilit Lim      */,
    blue: '#1689f1' /* Bright Ballsy Blue   */,
    lightBlue: '#41adf8' /* Light Ballsy Blue    */,
    red: '#eb3212' /* Bright Abs-olute Red */,
    lightRed: '#eb5035' /* Light Abs-olute Red  */,
    xLightGray: '#fafafa' /* Black 2%             */,
    lightGray: '#e6e6e6' /* Black 10%            */,
    gray: '#cccccc' /* Black 20%            */,
    mediumGray: '#a0a0a0' /* Black 40%            */,
    lightBlack: '#313232' /* Black 80%            */,
    black: '#000000' /* Black                */,
    menstrual: '#FA6155' /* Mentrual Phase        */,
    follicular: '#BDD175' /* Follicular Phase     */,
    ovulatory: '#FDA9C8' /* Ovulatory Phase       */,
    luteal: '#ABC2F8' /* Luteal Phase             */,
    pnfBg: '#FCF3ED' /* Phase and Function Bg     */,
    pnfIntroBg: '#FAEFE9' /* Phase and Function Intro Bg */,
};

const Colors = {
    ..._Colors,
    text: _Colors.lightBlack,
};

export default Colors;

export type ColorNames = keyof typeof _Colors;
